module.exports = __webpack_public_path__ + "media/Red_Carpet_Event.bff6eaf6.mp4";